module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel202309_04_1280_1280_en-310038793fdfc0f888b2c67b9db00506.jpg";